import { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import React from 'react';
import { SIDE } from '../helpers/consts-and-types';

export const UrlSettingsContext = createContext();

const UrlSettingsProvider = ({ children }) => {
  const [leftUrl, setLeftUrl] = useState('');
  const [rightUrl, setRightUrl] = useState('');

  useEffect(() => {
    const newUrl = new URL(window.location.origin);
    newUrl.search = `${leftUrl}&${rightUrl}`;
    window.history.pushState({ path: newUrl.toString() }, '', newUrl);
  }, [leftUrl, rightUrl]);

  const copyUrlToClipboard = useCallback(() => navigator.clipboard.writeText(window.location.href), []);

  const setPartUrl = useCallback((side, url) => {
    if (side === SIDE.Left) {
      setLeftUrl(url);
    } else if (side === SIDE.Right) {
      setRightUrl(url);
    }
  }, []);

  const value = useMemo(() => ({ copyUrlToClipboard, setPartUrl }), [copyUrlToClipboard, setPartUrl]);

  return <UrlSettingsContext.Provider value={value}>{children}</UrlSettingsContext.Provider>;
};

UrlSettingsProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default UrlSettingsProvider;
